import React from 'react';
import * as ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { REHYDRATE } from 'redux-persist/constants';
import { ThemeService } from '../services/ThemeService';
import { ConfigurationService, fetchRetailProductCategories } from '../services/ConfigurationService';
import { themeSystemDefault } from '../constants/SystemDefaults';
import { sbemShadCNThemeDefault } from '../constants/SystemDefaults';
import { SAVE_LEVEL } from '../constants/Level';
import { fetchLanguages } from '../components/helpers/fetchLanguages';
import { fetchLabels } from '../components/helpers/fetchLabels';
import { OAuthActions } from '../../lib/redux-oauth2-actions';
import { FileService } from '../services/fileUpload/uploadFile';
import { find, get } from 'lodash';
import { SET_IN_CONTEXT_BETA } from '../constants/ActionTypes';
import { isSbemTheme } from '../components/helpers/isSbemTheme';

// Hmm FIXME: TODO: wtf: localStorage persistance not working?
// Is that a bug with redux-actions?
let selected = JSON.parse(localStorage.getItem('reduxPersist:app'));
let selectedHotel = {};
if (selected && selected.selected && selected.selected.selectedHotel) {
    selectedHotel = selected.selected.selectedHotel;
}
const selectionDefaults = {
    level: SAVE_LEVEL.HOTEL,
    hotel: { Id: 'hotel1138' },
    brand: { Id: 'brandX' },
    chain: { Id: '23', name: '', primary: false },
    contentCode: 'default',
    currentTheme: themeSystemDefault,
    selectedHotel: selectedHotel,
    themeList: [],
    images: []
};

const selectionReducer = handleActions(
    {
        [ActionTypes.ADD_THEME_LIST]: (state, action) => {
            const newState = { ...state, themeList: action.themeList };
            
            if (action.defaultContent) {
                newState.defaultContent = action.defaultContent;
            }
            
            if (action.defaultContentSbem) {
                newState.defaultContentSbem = action.defaultContentSbem;
            }

            return newState;
        },
        [ActionTypes.ADD_CONFIG_LIST]: (state, action) => {
            if (action.defaultContent) {
                return { ...state, configList: action.configList, defaultContentConfig: action.defaultContent };
            }
            return { ...state, configList: action.configList };
        },
        [ActionTypes.SELECT_SAVE_LEVEL]: (state, action) => {
            return { ...state, level: action.level };
        },
        [ActionTypes.SAVE_SET_SELECTED_CHAIN]: (state, action) => {
            return { ...state, chain: { Id: action.chain } };
        },
        [ActionTypes.SAVE_SET_SELECTED_BRAND]: (state, action) => {
            return { ...state, brand: { Id: action.brand } };
        },
        [ActionTypes.SAVE_SET_SELECTED_HOTEL]: (state, action) => {
            return { ...state, hotel: { Id: action.hotel } };
        },
        [ActionTypes.SAVE_SET_THEME_NAME]: (state, action) => {
            return { ...state, contentName: action.name };
        },
        [ActionTypes.SAVE_SET_THEME_ID]: (state, action) => {
            if (action.id) {
                return { ...state, contentCode: action.id };
            } else {
                return { ...state, contentCode: 'systemdefault' };
            }
        },
        [ActionTypes.LOGIN_SET_CHAINID]: (state, action) => {
            return { ...state, chain: { Id: action.chain, name: action.name } };
        },
        [ActionTypes.LOGIN_SET_DEFAULT_HOTEL]: (state, action) => {
            return { ...state, selectedHotel: action.defaultHotel };
        },
        [ActionTypes.SET_DEFAULT_HOTEL]: (state, action) => {
            return { ...state, selectedHotel: action.payload.hotel };
        },
        [ActionTypes.SET_ASSETS_LIST]: (state, action) => {
            return { ...state, assets: action.assetsList };
        },
        [ActionTypes.SET_LANGUAGE_LIST]: (state, action) => {
            return { ...state, languageList: action.languageList, defaultCode: action.languageCode };
        },
        [ActionTypes.SET_RETAIL_PRODUCT_CATEGORIES]: (state, action) => {
            return { ...state, retailProductCategories: action.categories };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            const isThemeSbem = action.isSbemTheme !== undefined ? action.isSbemTheme : isSbemTheme(state.themeList, action.code);
            const themeSystemDefault = !isThemeSbem ? selectionDefaults.currentTheme : sbemShadCNThemeDefault;
            return { ...state, currentTheme: Object.assign({}, themeSystemDefault, action.theme), code: action.code, isThemeSbem };
        },
        [ActionTypes.REFRESH_SELECTED_THEME_FILE]: state => {
            return { ...state, code: undefined, themeToSave: undefined, themeFileChanged: undefined };
        },
        [ActionTypes.SET_THEME_FILE_READY_TO_SAVE]: (state, action) => {
            return { ...state, themeFileChanged: action.themeFileChanged };
        },
        [ActionTypes.SET_THEME_FILE_DATA]: (state, action) => {
            return { ...state, themeToSave: action.themeToSave };
        },
        [OAuthActions.OAUTH_SIGNOUT]: (state, actions) => {
            return { ...state, level: SAVE_LEVEL.HOTEL };
        },
        [ActionTypes.SET_IN_CONTEXT_BETA]: (state, action) => {
            return { ...state, inContextBeta: action.inContextBeta };
        }
    },
    selectionDefaults
);

const actions = {
    setSelectedChain(chain) {
        return { type: ActionTypes.SAVE_SET_SELECTED_CHAIN, chain: chain };
    },
    setSelectedBrand(brand) {
        return { type: ActionTypes.SAVE_SET_SELECTED_BRAND, brand: brand };
    },
    setSelectedHotel(hotel) {
        return { type: ActionTypes.SAVE_SET_SELECTED_HOTEL, hotel: hotel };
    },
    setThemeNameForSave(name) {
        return { type: ActionTypes.SAVE_SET_THEME_NAME, name: name };
    },
    setThemeIdForSave(id) {
        return { type: ActionTypes.SAVE_SET_THEME_ID, id: id };
    },
    loginSetSelectedHotel(hotel) {
        return { type: ActionTypes.LOGIN_SET_DEFAULT_HOTEL, selectedHotel: hotel };
    },
    selectSaveLevel(level) {
        return (dispatch, getState) => {
            const {
                app: {
                    selected: {
                        selectedHotel: { id: hotelId },
                        chain: { Id: chainId }
                    }
                }
            } = getState();
            dispatch({ type: ActionTypes.SELECT_SAVE_LEVEL, level });
            //TODO: temporary mapping
            //TODO: avoid duplicated code, see Login.js
            fetchLanguages(
                hotelId,
                languageList => {
                    dispatch({ type: ActionTypes.SET_LANGUAGE_LIST, languageList });
                },
                languageCode =>
                    dispatch({ type: ActionTypes.CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode: languageCode })
            ).then(response => {
                if (level === SAVE_LEVEL.HOTEL) {
                    const languageCode = get(find(response, { isDefault: true }), 'code') || 'en-US';
                    fetchRetailProductCategories({ hotelId, languageCode })
                }
            });
            /*   fetchLabels(chainId, hotelId , 'en-US', (foldedValue, explicitValue, languageCode) => {
        dispatch({ type: ActionTypes.SET_LABELS, foldedValue, explicitValue, languageCode })
      }, (foldedValue) => {
        dispatch({ type: ActionTypes.SET_HIGHER_ORDER_LABELS, foldedValue })
      });*/
            return Promise.all([
                ThemeService.reload(chainId, hotelId, level),
                ConfigurationService.reload(chainId, hotelId, level)
            ]);
        };
    },
    setDefaultHotel(hotel) {
        return { type: ActionTypes.SET_DEFAULT_HOTEL, defaultHotel: hotel };
    }
};

export { selectionReducer, actions };



// WEBPACK FOOTER //
// ./src/store/LevelSelection.js